export default {"src":"/_next/static/media/MSMEs.369933e5.svg","height":50,"width":50};